import React, { useState } from 'react';
import styled from 'styled-components';
import SelectDropDownSmallBtn from '../common/button/SelectDropDownSmallBtn';
import CheckBtn from '../common/button/CheckBtn';
import CheckBoxInput from '../common/input/CheckBoxInput';
import SelectDropDownBtn from '../common/button/SelectDropDownBtn';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { reqEsItemListAction, allAddCheckItemAction, allDellCheckItemAction, delEsItemAction, reqEsItemListIngAction, reqEsItemListDoneAction} from '../../modules/es/esItemModule';
import SelectOrderBox from '../common/button/SelectOrderBox';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../common/popup/NormalPopup';
import NormalPopupOneBtn from '../common/popup/NormalPopupOneBtn';
import {isMobileOnly} from 'react-device-detect';

const EsMainTabBlock = styled.div`
.filter-top { 
  .tab-list li {
    float: left;
    padding: ${isMobileOnly?"20px 10px 3px":"20px 25px"};
    &:first-child {
      padding-left: ${isMobileOnly?"0":"20px"};
    }
    &.vertical-bar {
      ${isMobileOnly?`
        padding: 21px 0 3px;
        button {font-weight:500;font-size:18px;}
      `:`
        display: none;
      `}
    } 
    button {
        font-size: ${isMobileOnly?"16px":"18px"};
    }       
  }  
}
`;

const Options = [
    { value: 0, label: "최신순" },
    { value: 1, label: "등록순" },
    { value: 2, label: "마감임박순" },
];


const EsMainTab = ({ tabList, handleTabClick, index }) => {

    const dispatch = useDispatch();

    const [curIdx, setCurIdx] = useState(0);
    const [order, setOrder] = useState(0);
    const [delAll, setDelAll] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [oneBtn, setOneBtn] = useState(false);
    const [msg, setMsg] = useState("");

    const { esItemCheck } = useSelector(
        ({ userReducer, esItemsReducer }) => ({
            esItemCheck: esItemsReducer.esItemCheck
        })
    );

    useEffect(() => {
        if(index !== curIdx) {
            //console.log("idx")
            setCurIdx(index)
        }
        
    }, [index, curIdx])

    const onChangeOrder = (param) => {
        setOrder(param.value);
        // 재조회
        //dispatch(reqEsItemListAction("type=" + curIdx + "&sort=" + param.value));
        dispatch(reqEsItemListIngAction());
    }

    // 전체 선택 버튼 클릭
    const handleAllCheckClick = (value) => {

        setDelAll(value);
        if (value) {
            dispatch(allAddCheckItemAction());
        } else {
            dispatch(allDellCheckItemAction());
        }
    }

    // 탭 버튼 클릭
    const hanldeTabIndexClick = (value) => {

        if (value !== curIdx) {
            setCurIdx(value);
            // 재조회
            //dispatch(reqEsItemListAction("type=" + value + "&sort=" + order));
            if(value === 0) {
                dispatch(reqEsItemListIngAction());
            } else {
                
                dispatch(reqEsItemListDoneAction());
            }
            
            handleTabClick(value);
        }
    }

    // 삭제 버튼 클릭
    const handleDeleteBtnClick = () => {

        // 팝업 표시

        if (esItemCheck === null || esItemCheck.length === 0) {
            setOneBtn(true)
            setMsg("삭제할 견적서를 선택해주세요.")
        } else {
            setOneBtn(false)
            setMsg("선택한 견적서를 삭제하시겠어요?")
        }
        setOpenModal(true);
    }

    /**
     * 삭제 처리
     */
    const delAction = () => {
        //console.log("esItemCheck : " + JSON.stringify(esItemCheck));
        dispatch(delEsItemAction(esItemCheck));
        handlePopupClose();
    }

    const handlePopupClose = () => {
        setOpenModal(false);
    }

    return (
        <EsMainTabBlock>
            <div className="filter-top clearfix" style={{border:'none'}}>
                <ul className="tab-list f-left clearfix">
                    {
                        tabList.map((tab) => {
                            return (
                                <React.Fragment key={tab.index}>
                                    {tab.index!==0&&<li className="vertical-bar"><button type="button"></button></li>}
                                    <li
                                        className={tab.index === curIdx ? "active" : ""}
                                    >
                                        <button
                                            type="button"
                                            className="green_border"
                                            style={{ color: tab.index === curIdx ? "#111" : "#999" }}
                                            onClick={() => hanldeTabIndexClick(tab.index)} >{tab.title}
                                        </button>
                                    </li>
                                </React.Fragment>
                            )
                        })
                    }
                </ul>

                {/* {!isMobileOnly&&<div className="filter-fc f-right clearfix">

                    <div className="f-left filter-all">
                        <CheckBoxInput title="전체 선택"
                            onClick={handleAllCheckClick}
                            defaultValue={delAll} />
                    </div>

                    <div className="f-left"
                        style={{ width: '140px', verticalAlign: 'baseline', marginRight: '20px' }}>

                        <SelectOrderBox
                            valueDefault={Options[order]}
                            options={Options}
                            onChange={onChangeOrder} />
                    </div>

                    <div className="f-left">
                        <button type="button"
                            className="delete-btn" onClick={handleDeleteBtnClick}/>
                    </div>
                </div>} */}
            </div>

            <Modal
                isOpen={openModal}
                onRequestClose={handlePopupClose}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {
                    oneBtn ?
                        <NormalPopupOneBtn
                            text=""
                            text2={msg}
                            text3=""
                            btn="닫기"
                            onClick={handlePopupClose} /> :
                        <NormalPopup
                            text=""
                            text2={msg}
                            text3=""
                            btn1="예" btn2="아니오"
                            onClick1={delAction}
                            onClick2={handlePopupClose} />
                }

            </Modal>

        </EsMainTabBlock>

    );
};

export default EsMainTab;
